import React, { useEffect } from 'react'
import { useLanguage } from '../i18n/LanguageContext'

export default function Lightbox({ images, currentIndex, isOpen, onClose, onPrev, onNext }) {
  const { t } = useLanguage()

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowLeft') onPrev()
      if (e.key === 'ArrowRight') onNext()
    }
    window.addEventListener('keydown', handleKeyDown)
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = ''
    }
  }, [isOpen, onClose, onPrev, onNext])

  if (!isOpen || !images || images.length === 0) return null

  const currentImg = images[currentIndex]

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 animate-fadeIn"
      onClick={onClose}
    >
      <div 
        className="relative max-w-5xl w-full max-h-[90vh] flex flex-col items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Top Controls */}
        <div className="absolute top-[-40px] right-0 flex items-center gap-4 text-white">
          <span className="text-sm font-medium text-slate-300">
            {currentIndex + 1} / {images.length}
          </span>
          <button
            onClick={onClose}
            className="p-2 text-slate-300 hover:text-white transition-colors rounded-full hover:bg-white/10"
            aria-label={t.lightbox?.close || 'Close'}
          >
            <i className="fa-solid fa-xmark text-2xl"></i>
          </button>
        </div>

        {/* Main Image */}
        <div className="relative w-full flex items-center justify-center">
          <img
            src={currentImg}
            alt={`${t.lightbox?.imageAlt || 'Gallery photo'} ${currentIndex + 1}`}
            className="max-h-[80vh] max-w-full object-contain rounded-lg shadow-2xl"
          />

          {/* Navigation Buttons */}
          {images.length > 1 && (
            <>
              <button
                onClick={onPrev}
                className="absolute left-2 md:left-4 p-3 bg-black/60 hover:bg-sky-600 text-white rounded-full transition-all duration-200 border border-white/20 hover:scale-105"
                aria-label={t.lightbox?.prev || 'Previous'}
              >
                <i className="fa-solid fa-chevron-left text-xl"></i>
              </button>
              <button
                onClick={onNext}
                className="absolute right-2 md:right-4 p-3 bg-black/60 hover:bg-sky-600 text-white rounded-full transition-all duration-200 border border-white/20 hover:scale-105"
                aria-label={t.lightbox?.next || 'Next'}
              >
                <i className="fa-solid fa-chevron-right text-xl"></i>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
